const str = `{HEADER}著作権ポリシー
{HEADER_SUB}本規約は（株）ビデオモンスター（以下‘当社’といいます）が運営するビデオモンスターウェブサイト又はアプリケーションから提供させていただく映像テンプレート及び各種コンテンツに対する著作権を規定する為のものとし、ビデオモンスターを利用されるユーザーは以下の項目に同意したとみなされます。


{BODY_TITLE}第一章　用語の定義
１）‘テンプレート’とは、当社がビデオモンスターを通して提供する情報伝達目的の予め制作された映像の結果物及び複数のデザイン要素によって構成されており、編集機（エディター）を通して編集が可能です。
２）‘デザイン要素’とは、テンプレートをなす単数又は複数の‘映像，イメージ，写真，アイコン，図形，テキストなど’と同様の要素をいいます。
３）‘編集機’とは、テンプレートを編集するソフトウェアを意味します。
４）‘利用者テンプレート’とは、利用者が提供されたテンプレートを編集機で作業した結果物を意味します。


{BODY_TITLE}第二章　ビデオモンスターの利用
１）当社がビデオモンスターを通して提供する全てのコンテンツ（テンプレートを含む全てのデザイン要素を通称）は、ビデオモンスターで著作権を所有しているか提携会社からビデオモンスター編集機の使用許可を得て提供されています。
２）利用者はビデオモンスターから提供されるデザイン要素を個別単独でダウンロード又はスクリーンショットなどを通し複製及び修正して使用する事が出来ません。ただし、ビデオモンスターから提供されるテンプレートはビデオモンスター編集機を通して修正が可能であり、これによる作業結果は使用が可能です。
３）利用者はコンテンツ及び編集機を当社の許可無しに他のサーバーにミラーリングする事が出来ません。
４）利用者はビデオモンスターから提供するテンプレートを製及び修正し、これを編集が可能なテンプレートとして再販売する事が出来ません。
５）無料利用者である場合、コンテンツに含まれるウォーターマーク又は当社のロゴなど当社により挿入された標識を除外する事が出来ません。
６）有料利用者である場合、企業や団体又は公共機関など再販売及び代行クライアント（広告代行）目的で使用する時には、これに適した料金プラン（現在‘再販売及びエージェンシー料金プラン’がこれに該当します）を使用しなくてはならず、月定期決済や期間制料金プランなど他の料金プランは再販売及び代行クライアントとして使用する事が厳格に禁止されます。この場合、当社は告知無しにサービスを中断する事ができ残余期間があったとしても払い戻しを受ける事が出来ません。
７）有料利用者は他人に利用権を譲渡，販売，レンタルは出来ません。
８）ビデオモンスターはエージェンシー料金プラン以外に同一のIDで同時に２名以上が接続し利用する事が出来ません。
９）利用者は本人のID及びパスワードを他人と供用し利用する事が出来ません。


{BODY_TITLE}第三章　利用者が制作したテンプレートの利用制限
１）ビデオモンスター編集機から提供されるテンプレートとデザイン要素から制作した利用者テンプレートは商業的又は非商業的用途で使用する事が出来ます。ただし、利用者がビデオモンスター編集機から直接アップロードしたデザイン要素に対しては利用者が直接許可範囲を確認されなくてはいけません。利用者がアップロードしたデザイン要素に対する著作権，肖像権，パブリシティー権に関する責任は利用者様にあります。
２）利用者はビデオモンスターから提供するテンプレート及びデザイン要素を利用し、これに創作性を加味して作られた‘利用者テンプレート’の再販売及び代行クライアントはエージェンシー料金プラン利用時にのみ可能です。ただし、これを編集が可能なテンプレート形態で配布及び販売や何の創作性も加味されていない複製物は販売出来ません。
３）利用者は編集機を利用し制作した利用者テンプレートを他の編集道具を使い再編集する事が出来ません。ただし、以下の項目は例外とします。
①ダウンロードした制作結果物のファイル形式変換は可能です。
②ダウンロードした制作結果物を他の映像に原本をそのまま挿入又は結合させ使用する事が出来ます。
③ダウンロードした制作結果物に字幕、吹き替え，要素，効果挿入又は長さを切る事や貼り付けをする事が出来ます。
４）利用者はビデオモンスターから提供される‘デザイン要素’が含まれた利用者テンプレートを使った知的財産権（著作権，商標権，デザイン権，特許権）の権利を一般的に登録・主張する事は出来ません。利用者がビデオモンスターから提供される‘デザイン要素’が含まれた二次著作物を制作し使用を許可又は譲渡する事によって第三者から収入を得ようとする場合、事前にビデオモンスターとこれに関する協議を申請しなければいけません。


{BODY_TITLE}第四章　当社の免責
１）当社はビデオモンスター内全てのコンテンツの内容及び意味に対し正確性や信頼性を保障せず、利用者がこれを利用する事によって発生する問題は利用者にあります。
２）‘利用者テンプレート’に込まれた内容及び意味から発生する全ての責任は当社にあらず、これを制作した利用者にあります。
３）利用者がアップロードしたデザイン要素の一部又は全てが、他人の権利を侵害した場合の責任は当社にあらずこれをアップロードした利用者にあります。
４）当社はユーザー相互間及びユーザーと第三者相互間において、サービスを媒介にした紛争に介入する義務は無く、それに対する損害を賠償する責任もありません。
５）利用者は当社との事前協議無しに‘著作権ポリシー’を超える用途でご使用される場合、制作した利用者テンプレートに対して著作権保護を受ける事が出来ず摘発時、刑事処罰や損害賠償の義務を負います。


{BODY_TITLE}第五章　制約事項
１）ビデオモンスターから提供された写真（イメージ）などをわいせつ目的で利用又は他人の名誉を毀損及び侮辱するなど、法に違反する目的では使用出来ません。
２）ビデオモンスターを通して社会美風良俗を阻害する用途（成人ゲームセンター，電話ルーム，わいせつ物，チャット，サイト，成人コミュニティ，成人製品，遊興業者及び宿泊業者などの成人関連サイト及び印刷物）や、高利貸，占い相談，合コン斡旋，結婚情報，宗教的，政治的目的での使用は禁じます。
３）ビデオモンスターから提供するミュージック（Music）やフォント（Font）以外のMYサービスから自身のミュージックやフォントでアップロードし使用する場合、配布が許可された他著作権の制約事項を必ず守らねばなりません。
４）ビデオモンスター内のピクセル（Pexels），ピクサベイ（Pixabay），ゲッティイメージズ（GettyImages）から提供される全てのイメージ及び動画は以下の制約事項を守らなくてはいけません。
①企業CI，BIロゴ及び整形，ポルノ，成人用品，麻薬，賭博，射幸性ゲーム関連及び誹謗を目的とする用途には利用出来ず、被写体に対する名誉毀損及び人格権侵害など一般情緒に反する用途としては利用出来ません。
②原本のままコピーし販売する事は出来ません。
③識別可能な人物や個人財産，商標，ロゴなどを使用する場合、法律や名誉毀損等の社会常規に違反もしくは専属モデルと誤認されなど他の製品やサービスと関連しているように見えるよう利用する事は出来ません。
＊規定の詳細は各ホームページからご確認可能であり、著作権規定に違反し元著作権者に被害が発生する場合責任は規定を違反した利用者にあります。

{BODY_TITLE}第六章　お問い合わせ
著作権に関連するお問い合わせは以下のeメールから可能です。
Email:support@videomonster.com
`

export default str